import { useTranslation } from "react-i18next";
import { useStyles } from "./CorporateReportsFilters.styles";
import useCorporateDashboardFilters, {
    initialCorporateDashboardFilters,
} from "pages/Corporate/CorporateDashboard/useCorporateDashboardFilters";
import MainSelect from "components/MainSelect/MainSelect.view";
import { FiltersDefaultButton } from "pages/Corporate/components/FiltersDefaultButton/FiltersDefaultButton.view";

const CorporateReportsFilters = () => {
    const { t } = useTranslation();
    const {
        filters,
        divisionOptions,
        regionOptions,
        productionLinesOptions,
        machineCentersOptions,
        trailingTrendPeriodOptions,
        handleFiltersChange,
        setFiltersDefault,
        handleRemoveDefaultFilters,
        isFiltersDefault,
        userFiltersDefault,
        loadingDefaultOperations,
    } = useCorporateDashboardFilters();
    const classes = useStyles();
    return (
        <div className={classes.mainWrapper}>
            <MainSelect
                order={"asc"}
                label={t("corporate_dashboard.filters.division")}
                onChange={(event) =>
                    handleFiltersChange({
                        division: event.target.value,
                        region: initialCorporateDashboardFilters.region,
                        productionLine: initialCorporateDashboardFilters.productionLine,
                        machineCenter: initialCorporateDashboardFilters.machineCenter,
                    })
                }
                value={filters.division}
                options={divisionOptions}
                tagClassName={classes.tag}
                small
            />
            <MainSelect
                order={"asc"}
                label={t("corporate_dashboard.filters.region")}
                onChange={(event) =>
                    handleFiltersChange({
                        region: event.target.value,
                        productionLine: initialCorporateDashboardFilters.productionLine,
                        machineCenter: initialCorporateDashboardFilters.machineCenter,
                    })
                }
                value={filters.region}
                options={regionOptions}
                tagClassName={classes.tag}
                small
            />
            <MainSelect
                order={"asc"}
                multiple
                label={t("corporate_dashboard.filters.production_line")}
                onChange={(event) =>
                    handleFiltersChange({
                        productionLine: event.target.value,
                        machineCenter: initialCorporateDashboardFilters.machineCenter,
                    })
                }
                value={filters.productionLine}
                options={productionLinesOptions}
                tagClassName={classes.tag}
                small
            />
            <MainSelect
                order={"asc"}
                multiple
                label={t("corporate_dashboard.filters.machine_center")}
                onChange={(event) => handleFiltersChange({ machineCenter: event.target.value })}
                value={filters.machineCenter}
                options={machineCentersOptions}
                tagClassName={classes.tag}
                small
            />
            <MainSelect
                label={t("corporate_dashboard.filters.trailing_trend_period.title")}
                onChange={(event) => handleFiltersChange({ trailingTrendPeriod: event.target.value })}
                value={filters.trailingTrendPeriod}
                options={trailingTrendPeriodOptions}
                tagClassName={classes.tag}
                small
            />
            <FiltersDefaultButton
                customStyles={{ fontSize: "10px" }}
                isSelected={isFiltersDefault}
                hasDefault={!!userFiltersDefault}
                handleOperation={isFiltersDefault ? handleRemoveDefaultFilters : setFiltersDefault}
                disabled={loadingDefaultOperations}
            />
        </div>
    );
};

export default CorporateReportsFilters;
